import Vue from 'vue'
import App from './App.vue'
import router from "./router"
import frame from './plugins/frame'
import vuescroll from 'vuescroll';
import TextTop from './components/view/frame/TextTop.vue'
import fetchCommonDataPlugin from './components/view/frame/FetchCommonData/v2/'
import commonData from './components/view/frame/FetchCommonData/'


commonData('appShortName_26').then(data => {
    commonData('appFullName_26').then(data1 => {

       document.getElementsByTagName('title')[0].innerHTML=data+data1+' - 估值视角研判股票价格'
    })
})


Vue.use(fetchCommonDataPlugin)
Vue.use(vuescroll);
Vue.component('TextTop',TextTop)
Vue.config.productionTip = false
Vue.use(frame)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
